import { render } from "./HeroiconsSolidDownload.vue?vue&type=template&id=0ff2aa28"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDownload.vue"]])

export default __exports__